export const GET_STUDYMATERIAL = "GET_STUDYMATERIAL"
export const GET_STUDYMATERIAL_SUCCESS = "GET_STUDYMATERIAL_SUCCESS"
export const RESET_STORE_STUDYMATERIAL = "RESET_STORE_STUDYMATERIAL"
export const DELETE_STUDYMATERIAL = "DELETE_STUDYMATERIAL"
export const DELETE_STUDYMATERIAL_SUCCESS = "DELETE_STUDYMATERIAL_SUCCESS"

